import {
  EquipmentGroup,
  EquipmentType,
} from '@energybox/react-ui-library/dist/types';
import { Actions } from '../actions/equipmentTags';

export type EquipmentTags = {
  equipmentGroups: EquipmentGroup[];
  equipmentTypes: EquipmentType[];
};

const initialState = {
  equipmentGroups: [],
  equipmentTypes: [],
};

export default (state: EquipmentTags = initialState, action: any) => {
  switch (action.type) {
    case Actions.EQUIPMENT_GROUPS_SUCCESS:
      return {
        ...state,
        equipmentGroups: action.payload,
      };
    case Actions.EQUIPMENT_TYPES_SUCCESS: {
      return {
        ...state,
        equipmentTypes: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
